<!--
 * @Author: xuesong
 * @Date: 2021-04-19 10:51:27
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-05-13 11:52:31
 * @Description: 系统消息-会诊-服务卡片
-->
<template>
  <div class="custom-syfive">
    <span class="team-logo"></span>
    <div class="info-content">
      <span class="text-title">专家协同服务</span>
      <span class="text-sign">发起人：{{ data.fromDoctorName }}</span>
      <span class="text-sign">参与专家：{{ data.admissionName }}</span>
      <span class="text-price">￥{{ data.price }}</span>
    </div>
    <span class="paied-icon" v-if="extension === '2015'"></span>
  </div>
</template>
  
  <script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    extension: {
      type: String,
      default: 0,
    },
  },
};
</script>
  
  <style scoped lang="less">
.custom-syfive {
  position: relative;
  width: 350px;
  cursor: pointer;
  display: flex;
  padding: 10px 7px;
  padding-right: 0;
  background: #FFFFFF;
  box-shadow: 0px 0px 10px 0px rgba(204,204,204,0.2);
  border-radius: 6px;
  border: 1px solid #F5F5F5;
  .team-logo {
    width: 35px;
    height: 35px;
    background: url(../../static/IMInput/team_icon.png) no-repeat;
    background-size: contain;
    margin-right: 6px;
  }
  .info-content {
    font-size: 12px;
    font-weight: 500;
    display: flex;
    flex-direction: column;
    text-align: left;

    span {
      font-size: 12px;
      color: #333333;
    }
    .text-title {
      font-size: 15px;
      font-weight: 500;
      color: #333333;
    }
    .text-sign {
      margin-top: 6px;
      font-size: 13px;
      color: #666666;
    }
    .text-price {
      margin-top: 8px;
      font-size: 15px;
      font-weight: 600;
      color: #3d76f6;
    }
  }
  .paied-icon {
    position: absolute;
    right: 4px;
    top: 4px;
    width: 66px;
    height: 66px;
    background: url(../../static/IMInput/paied_icon.png) no-repeat;
    background-size: contain;
  }
}
</style>